export default {
	namespaced: true,
	state: {
		items: []
		
	},
	getters: {
        items(state){
			return state.items;
		}
	},
	mutations: {
		clearItems(state){
			state.items = []
		},
        loadItems(state, data){
			state.items = data
		}
	},
	actions: {
        loadItems(context, data){
			context.commit('clearItems');
			context.commit('loadItems', data)
        }
	}
};


// WEBPACK FOOTER //
// ./src/store/modules/metaInfo.js